export const getLinksByLanguage = (language: string) => {
  const isKo = language === "ko";
  const links = {
    ismsBanner:
      "https://medium.com/henesis/특금법-가상자산사업자-isms인증-해치랩스-헤네시스월렛-플라이빗-소프트와이드시큐리티-43f3f44775da",
    docs: "https://v1.docs.henesis.io/docs",
    tutorials: "https://v1.docs.henesis.io/docs/tutorial-create-master-wallet",
    apis: "https://v1.docs.henesis.io/reference/latest-version",
    talkToSales: isKo
      ? "https://haechi.typeform.com/to/YgoqYhFJ?utm_source=website&utm_campaign=main"
      : "https://haechi.typeform.com/to/lQJKlKpb?utm_source=website&utm_campaign=main",
    home: {
      usecasesSection: {
        usecaseWalletService: `https://medium.com/henesis/%EC%84%B1%EA%B3%B5%EC%82%AC%EB%A1%80-%EB%B9%84%ED%8A%B8%EB%B2%A0%EB%A6%AC%EA%B0%80-15%EB%A7%8C%EB%AA%85-%EC%9C%A0%EC%A0%80%EC%9D%98-%EC%9E%90%EC%82%B0%EC%9D%84-%EB%B3%B4%EA%B4%80%ED%95%98%EB%8A%94-%EB%B9%84%EA%B2%B0-c34635687bf1`,
        usecaseExchange2Service: `https://medium.com/henesis/%ED%94%8C%EB%9D%BC%EC%9D%B4%EB%B9%97-%EA%B5%AD%EB%82%B4-9%EB%B2%88%EC%A7%B8-isms-%EC%9D%B8%EC%A6%9D-%EC%B7%A8%EB%93%9D-%EC%A7%80%EB%82%9C-9%EC%9B%94-%ED%97%A4%EB%84%A4%EC%8B%9C%EC%8A%A4-%EC%9B%94%EB%A0%9B-%EB%8F%84%EC%9E%85-b9354b765621`,
        usecaseExchange2EnService: `https://medium.com/henesis-wallet/why-flybit-a-major-virtual-asset-exchange-in-korea-adopted-henesis-7011c4af968f`,
        usecaseConsignmentService: `https://bit.ly/3CkscVO`,
        usecaseConsignmentEnService: `https://medium.com/henesis-wallet/haechi-labs-establishes-koda-a-digital-asset-management-company-with-kb-kookmin-and-hashed-c0ee98f8bd90`,
        usecasePaymentService: `https://bit.ly/2X0vk97`,
      },
      saveGasFeesSection: isKo
        ? "https://haechi.typeform.com/to/fLN7MDlp?utm_source=website&utm_campaign=gasfeeanalysis"
        : "https://haechi.typeform.com/to/fLN7MDlp?utm_source=website&utm_campaign=gasfeeanalysis",
      dashboardSection: isKo
        ? `https://docs.henesis.io/docs#%EB%8C%80%EC%8B%9C%EB%B3%B4%EB%93%9C-%EB%A1%9C%EA%B7%B8%EC%9D%B8`
        : `https://docs.henesis.io/docs#대시보드-로그인`,
      apiSection: `https://docs.henesis.io/reference/latest-version`,
    },
    product: {
      enterpriseGradeSecuritySection: {
        multisigWallet: `https://docs.henesis.io/docs/concept-multi-signature-wallet`,
        authority: `https://docs.henesis.io/docs/feature-manage-organization`,
        withdrawalPolicy: `https://docs.henesis.io/docs/feature-withdrawal-policy`,
        networkSecurity: `https://docs.henesis.io/docs/feature-api-security`,
        monitoring: `https://docs.henesis.io/docs/feature-alarm`,
      },
      transactionFeeManagementSection: {
        gasFee: `https://docs.henesis.io/docs/faq-ethereum-transaction-fee-comparison`,
        feeWallet: `https://docs.henesis.io/docs/feature-fee-wallet`,
      },
      dashboardAndAPISection: {
        dashboard: `https://docs.henesis.io/docs#%EB%8C%80%EC%8B%9C%EB%B3%B4%EB%93%9C-%EB%A1%9C%EA%B7%B8%EC%9D%B8`,
        api: `https://docs.henesis.io/docs`,
      },
      saveGasFeesSection: isKo
        ? "https://haechi.typeform.com/to/YgoqYhFJ?utm_source=website&utm_campaign=bottom"
        : "https://haechi.typeform.com/to/lQJKlKpb?utm_source=website&utm_campaign=bottom",
    },
  };
  return links;
};
